import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const increaseATBButtonOnPdpSelector = createSelector(testTargetOffersSelector, offers => offers.increaseATBButtonOnPDP || Empty.Object);

export { increaseATBButtonOnPdpSelector };
